import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { ControlledTextField } from '../form/ControlledTextField'
import { FormGroup } from '../form/FormGroup'
import { validators } from '../../validation/validators'
import { WizardStep, WizardStepProps } from '../form/WizardStep'

export type PricingModelBasicInfoFormValues = {
  name: string
  buildingYear: string
  inspectionLengthInYears: string
  yearlyDiscountRate: string
  yearlyMaintenanceIncreaseRate: string
}

type Props = WizardStepProps<PricingModelBasicInfoFormValues> & {
  onSubmit: (values: PricingModelBasicInfoFormValues) => void
}

export function PricingModelBasicInfoStep(props: Props): React.ReactElement {
  const { defaultValues, onSubmit } = props
  const { t } = useTranslation()
  const { control, handleSubmit, errors } =
    useForm<PricingModelBasicInfoFormValues>({
      defaultValues,
    })

  const title = t('pricingModels.basicInfo') ?? ''

  return (
    <WizardStep
      {...props}
      title={title}
      onSubmit={handleSubmit(onSubmit)}
      dataCy="basic-info-step"
    >
      <FormGroup>
        <ControlledTextField
          control={control}
          name="name"
          rules={validators.required}
          error={errors.name}
          label={t('pricingModels.name')}
          defaultValue={t('pricingModels.nameDefaultValue')}
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="buildingYear"
          rules={validators.required}
          error={errors.buildingYear}
          label={t('pricingModels.buildingYear')}
          defaultValue="2022"
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="inspectionLengthInYears"
          rules={validators.required}
          error={errors.inspectionLengthInYears}
          label={t('pricingModels.inspectionLengthInYears')}
          defaultValue="25"
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="yearlyDiscountRate"
          rules={validators.required}
          error={errors.yearlyDiscountRate}
          label={t('pricingModels.yearlyDiscountRate')}
          defaultValue="5"
        />
      </FormGroup>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="yearlyMaintenanceIncreaseRate"
          rules={validators.required}
          error={errors.yearlyMaintenanceIncreaseRate}
          label={t('pricingModels.yearlyMaintenanceIncreaseRate')}
          defaultValue="5"
        />
      </FormGroup>
    </WizardStep>
  )
}
